 var initPassword = function () {
    var dialog, form;
    
    var changePassword = function () {
        if ($("input[name='NewPassword']").val().length === 0) {
            $("#validationMessage").text("Please enter your old password and try again.");
            return false;
        };

        if ($("input[name='NewPassword']").val() !== $("input[name='NewPasswordConfirmation']").val()) {
            $("#validationMessage").text("Your new password and its confirmation must match. Please try again.");
            return false;
        }   

        var jsonData = JSON.stringify({ userId: $("input[name='Id']").val(), oldPassword: $("input[name='OldPassword']").val(), newPassword: $("input[name='NewPassword']").val() });
        $.ajax({
            method: "POST",
            url: form.attr('action'),
            data: jsonData,
            dataType: "json",
            traditional: true,
            contentType: "application/json; charset=utf-8"
        })
        .done(function (data) {
            if (data.Success === false) {
                $("#validationMessage").text(data.Message);
            } else {
                $("input[name='OldPassword']").val("");
                $("input[name='NewPassword']").val("");
                $("input[name='NewPasswordConfirmation']").val("");
                dialog.dialog("close");
            }
        });

        return true;
    };
    
    dialog = $("#passwordModal").dialog({
        autoOpen: false,
        height: 400,
        width: 350,
        modal: true,
        close: function () {
            form[0].reset();
            dialog.hide();
        }
    });

    form = dialog.find("form").on("submit", function (event) {
        event.preventDefault();
        changePassword();
    });

    $("#btnChangePassword").button().on("click", function () {
        dialog.dialog("open");
    });
     
 };

